import { clearAllData } from '../../actions';
import { useDispatch } from 'react-redux';
import './style.scss';

const StartOverButton = (props) => {
  const dispatch = useDispatch();

  return (
    <div className="start-over-button-container">
      <button
        type="button"
        className="start-over-button"
        onClick={(e) => {
          e.preventDefault();
          dispatch(clearAllData());
        }}
      >start over</button>
    </div>
  );
};

export default StartOverButton;
